export { DMS_MODULE } from '../constants';
export const NAME = 'SkladNdSestavy';
export const API_NAME = 'SkladNd';
export const CRUMB_LABEL_KEY = 'StandRepSklad';
export const INVENTORY_PARTS_DATA = 'InventoryPartsData';

export enum RozsahDate {
	casDnes,
	casVcera,
	casTentoMesic,
	casMinulyMesic,
	casTentoRok,
	casMinulyRok,
	casMinulyKvart,
	casLibObdobi,
}
export enum Inventory {
	INVENTORY_MAIN_PAGE = 'Inventory',
	INVENTORY_DASHBOARD = 'InventoryDashboard'
}

export enum AccessSestavyFlagEnum {
	NONE = 0,
	DODAVATEL = 1,
	NDPOHYB = 2,
	NDSKLAD = 4,
	P_NDPOHYB = 8,
	PRACOVNIK = 16,
	S_ZAKAZKADRUH = 32,
	SKLAD = 64,
	ZAKAZNIK = 128,
	ZAKAZKA = 256,
	PROVOZOVNA = 512
}

const permission = {
	ndSkladZakPolozky: <const>AccessSestavyFlagEnum.S_ZAKAZKADRUH && AccessSestavyFlagEnum.NDPOHYB
		&& AccessSestavyFlagEnum.PROVOZOVNA && AccessSestavyFlagEnum.ZAKAZKA,
	prijemNDDodList: <const>AccessSestavyFlagEnum.DODAVATEL && AccessSestavyFlagEnum.NDPOHYB
		&& AccessSestavyFlagEnum.P_NDPOHYB && AccessSestavyFlagEnum.SKLAD,
	prehledProvedenychKorekciPCND: <const>AccessSestavyFlagEnum.NDPOHYB && AccessSestavyFlagEnum.P_NDPOHYB
		&& AccessSestavyFlagEnum.SKLAD && AccessSestavyFlagEnum.PRACOVNIK,
	prehledProvedenychKorekciStavuND: <const>AccessSestavyFlagEnum.NDPOHYB && AccessSestavyFlagEnum.P_NDPOHYB
		&& AccessSestavyFlagEnum.SKLAD && AccessSestavyFlagEnum.PRACOVNIK,
	oductovaneKorekcePncZaObdobi: <const>AccessSestavyFlagEnum.NDPOHYB && AccessSestavyFlagEnum.P_NDPOHYB
		&& AccessSestavyFlagEnum.SKLAD && AccessSestavyFlagEnum.PRACOVNIK,
	kontrolniOpisSkladoveVydejky: <const>AccessSestavyFlagEnum.DODAVATEL && AccessSestavyFlagEnum.NDPOHYB
		&& AccessSestavyFlagEnum.P_NDPOHYB && AccessSestavyFlagEnum.SKLAD && AccessSestavyFlagEnum.PRACOVNIK
		&& AccessSestavyFlagEnum.ZAKAZNIK,
	Inventory: AccessSestavyFlagEnum.SKLAD && AccessSestavyFlagEnum.PRACOVNIK,
};

export const buttons = <const>[
	{
		labelKey: 'cmdNDSkladZakPolozky',
		routeName: 'NDSkladZakPolozky',
		api: 'GetVydanoZeSkladuPoZakazkachPolozkove',
		permission: permission.ndSkladZakPolozky,
	},
	{
		labelKey: 'cmdPrijemNDDodList',
		routeName: 'PrijemNDDodList',
		api: 'GetPrijemNdNaSkladZaObdobiPoPrijemkach',
		permission: permission.prijemNDDodList,
	},
	{
		labelKey: 'cmdKorekcePCND',
		routeName: 'PrehledProvedenychKorekciPCND',
		api: 'GetPrehledProvedenychKorekciPCND',
		permission: permission.prehledProvedenychKorekciPCND,
	},
	{
		labelKey: 'cmdKorekceStavND',
		routeName: 'PrehledProvedenychKorekciStavuND',
		api: 'GetPrehledProvedenychKorekciStavuND',
		permission: permission.prehledProvedenychKorekciStavuND,
	},
	{
		labelKey: 'cmdNDSkladVydano',
		routeName: 'VydejZboziZeSkladuZaObdobi',
		api: 'GetVydejZboziZeSkladuZaObdobi',
		permission: permission.prehledProvedenychKorekciStavuND,
	},
	{
		labelKey: 'cmdOductKorekcePNC',
		routeName: 'OductovaneKorekcePncZaObdobi',
		api: 'GetOductovaneKorekcePncZaObdobi',
		permission: permission.oductovaneKorekcePncZaObdobi,
	},
	{
		labelKey: 'cmdNDSkladVydejkaOpis',
		routeName: 'KontrolniOpisSkladoveVydejky',
		api: 'GetKontrolniOpisSkladoveVydejky',
		permission: permission.kontrolniOpisSkladoveVydejky,
	},
	{
		labelKey: 'cmdNDSkladInventoryDashboard',
		routeName: 'Inventory',
		api: 'GetInventoryDashboard',
		permission: permission.Inventory,
	},
];

export const DEPENDENT_TABLES = <const>[
	INVENTORY_PARTS_DATA,
];

export type DependentTableNames = typeof DEPENDENT_TABLES[number];

export type SestavaButton = { labelKey: string, routeName: string, api: string, permission: number };
